import { useSelector } from 'react-redux'

export default function useEntity(entityName, id) {
  const entity = useSelector(({ entities: { [entityName]: entities } }) => entities[id])
  return entity
}
